import React, { useState } from "react";
import { FormatDate } from "components/FormatDate";
import useSettings from "stores/settings";

import MaterialModal from "components/modal/MaterialModal";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import { BasicAlert } from "components/Alert";

import { projectFirestore } from "components/ProjectFirestore";

const MessageSendModal = ({ messageModalVisible, closeModal, receiveEmail, receiveUserName }) => {
  const settings = useSettings();
  const [message, setMessage] = useState("");

  const handleModalOkButton = async () => {
    const date = new Date();
    const createdAt = FormatDate(date);

    if (message === "") {
      const text = "전송할 메시지 내용을 작성해주세요.";
      BasicAlert(text);
      return;
    }

    /**
     * 메세지 저장 위치 : users/{email}/message/{randomId}
     */

    const sendEmail = settings.email;
    const sendUserName = settings.name;

    try {
      const collectionRefReceive = await projectFirestore.collection("users").doc(receiveEmail).collection("message");

      const values = {
        sendEmail,
        sendUserName,
        message,
        receiveEmail,
        receiveUserName,
        createdAt,
      };

      await collectionRefReceive.add(values).then(async (doc) => {
        const docRefSend = await projectFirestore.collection("users").doc(sendEmail).collection("message").doc(doc.id);
        await docRefSend.set(values);
      });

      setMessage("");
      closeModal();
      BasicAlert("메시지가 전송되었습니다.");
    } catch (error) {
      console.log(error);
      setMessage("");
      closeModal();
      BasicAlert("메시지 전송 실패");
    }
  };
  return (
    <MaterialModal open={messageModalVisible} closeModal={closeModal}>
      <div className="popup-content center modal-width-150">
        <div className="popup-header">
          <div className="h-full">
            <IconButton aria-label="close" className="w-15 h-15" onClick={() => closeModal()}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <h5 className="text-primary font-gmarket-medium text-2xl font-bold mb-4 center">메시지 전송</h5>

        <div className="w-full flex justify-start px-4">
          <p className="pr-2">받는 사람</p>
          <p className="pr-2">:</p>
          <p>{receiveUserName ? (receiveUserName.length > 15 ? `${receiveUserName.slice(0, 15)}...` : receiveUserName) : ""}</p>
        </div>
        <div className="popup-body flex flex-col justify-center items-center">
          <div className="w-full">
            <TextField
              placeholder="메시지 내용을 입력하세요"
              fullWidth
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              multiline
              rows={8}
              className="w-full"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </div>
        <div className="popup-footer center">
          <button type="button" className="btn btn-modal-o w-2/3 py-3" onClick={() => handleModalOkButton()}>
            보내기
          </button>
        </div>
      </div>
    </MaterialModal>
  );
};

export default MessageSendModal;
